module.exports = __webpack_public_path__ + "img/Medico-social.5cd915df.png";